// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import newsletterRecipientEntity from './entities/newsletter-recipient.json';
import newsletterRecipientMenu from '../pages/newsletter-recipient/menu.json';
import newsletterRecipientFullForm from '../pages/newsletter-recipient/forms/full.json';
import newsletterRecipientContextForm from '../pages/newsletter-recipient/forms/context.json';
import newsletterRecipientMiniForm from '../pages/newsletter-recipient/forms/mini.json';
import newsletterRecipientLookupForm from '../pages/newsletter-recipient/forms/lookup.json';
import newsletterRecipientTableView from '../pages/newsletter-recipient/views/table.json';
import newsletterRecipientCardsView from '../pages/newsletter-recipient/views/cards.json';
import newsletterRecipientDashboardView from '../pages/newsletter-recipient/views/dashboard.json';

/** Тип запису «Одержувач» зі сторінками пакета: меню, форми та подання з pages/newsletter-recipient/. */
export const newsletterRecipientDefinition: IRecordTypeDefinition = {
  ...newsletterRecipientEntity,
  views: assembleViewSet({
      table: newsletterRecipientTableView,
      cards: newsletterRecipientCardsView,
      dashboard: newsletterRecipientDashboardView,
  }),
  form: newsletterRecipientFullForm,
  forms: { full: newsletterRecipientFullForm, context: newsletterRecipientContextForm, mini: newsletterRecipientMiniForm, lookup: newsletterRecipientLookupForm },
  menu: newsletterRecipientMenu,
} as IRecordTypeDefinition;
